var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStackOverflowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 16V11H16V18H2V11H4V16H14Z",
    fill: "#BCBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.09 0.722916L10.8775 1.62476L15.3867 7.68684L16.5992 6.78499L12.09 0.722916Z",
    fill: "#F48024"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H13V13H5V15Z",
    fill: "#F48024"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1477 9.13223L8.34235 4.29697L9.3093 3.13579L15.1152 7.97105L14.1477 9.13223Z",
    fill: "#F48024"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44709 7.6572L13.2962 10.847L13.9339 9.47678L7.08484 6.28749L6.44709 7.6572Z",
    fill: "#F48024"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9806 12.6551L5.40145 11.3905L5.7797 9.71865L13.1968 11.1981L12.9806 12.6551Z",
    fill: "#F48024"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackOverflowIcon);
export default __webpack_public_path__ + "static/media/stack-overflow-icon.cd0b4231.svg";
export { ForwardRef as ReactComponent };